import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Label } from '@folio/stripes-components';
import { useIntl } from 'react-intl';
import FieldViewGenerator from './FieldViewGenerator';
import css from './styles.css';

function FieldViewBuilder({ data, template, entityType, controlledVocab }) {
  const { locale } = useIntl();

  return (
    <>
      {template.templateFields[entityType].map((section) => {
        return (
          <div key={section.sectionId}>
            <Accordion
              id={`template-form-generator-${section.sectionId}`}
              label={
                <Label fullWidth>
                  <h2>
                    {
                      section?.sectionLabel?.find(
                        (label) => label.locale === locale,
                      )?.value
                    }
                  </h2>
                </Label>
              }
            >
              {section?.sectionFields?.map((field, index) => {
                return (
                  <div
                    className={css.fieldContainer}
                    key={`${field.name}-${index}`}
                  >
                    <FieldViewGenerator
                      fieldValues={field}
                      index={index}
                      locale={locale}
                      data={data}
                      controlledVocab={controlledVocab}
                    />
                  </div>
                );
              })}
            </Accordion>
          </div>
        );
      })}
    </>
  );
}

FieldViewBuilder.propTypes = {
  data: PropTypes.object,
  template: PropTypes.object,
  entityType: PropTypes.string,
  controlledVocab: PropTypes.object,
};

export default FieldViewBuilder;
